import { SocketEvent } from './socket-event';
import { Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as io from 'socket.io-client';

export abstract class WebSocketIoBase {
    private readonly connectEventSubscription: Subscription;
    private readonly disconnectEventSubscription: Subscription;
    private readonly errorEventSubscription: Subscription;
    private sioClient: SocketIOClient.Socket;
    private readonly SIO_EVENTS = {
        CONNECT: new SocketEvent('connect', new Subject<any>()),
        DISCONNECT: new SocketEvent('disconnect', new Subject<any>()),
        ERROR: new SocketEvent('error', new Subject<any>()),
        // No need to log the connect_error: it is already logged by the socket.io library
        CONNECT_ERROR: new SocketEvent('connect_error', new Subject<any>())
    };

    protected constructor() {
        this.connectEventSubscription = this.SIO_EVENTS.CONNECT.observable
            .pipe(tap((event) => console.log(`Websocket connected:`, event)))
            .subscribe();
        this.errorEventSubscription = this.SIO_EVENTS.ERROR.observable
            .pipe(tap((event) => console.warn(`Websocket error:`, event)))
            .subscribe();
        this.disconnectEventSubscription = this.SIO_EVENTS.DISCONNECT.observable
            .pipe(
                tap((event) => console.warn(`Websocket disconnected:`, event))
            )
            .subscribe();
    }

    protected unsubscribeSioEvents(): void {
        if (this.connectEventSubscription != null) {
            this.connectEventSubscription.unsubscribe();
        }
        if (this.errorEventSubscription != null) {
            this.errorEventSubscription.unsubscribe();
        }
        if (this.disconnectEventSubscription != null) {
            this.disconnectEventSubscription.unsubscribe();
        }
    }

    protected closeSocketConnection(): void {
        if (this.sioClient != null) {
            this.sioClient.close();
        }
    }
    protected get socketIoClient(): SocketIOClient.Socket {
        return this.sioClient;
    }

    protected abstract get events(): SocketEvent<any>[];

    protected get allEvents(): SocketEvent<any>[] {
        return Object.values(this.SIO_EVENTS).concat(this.events);
    }

    protected openSocketConnectionInternal(
        url: string,
        options: SocketIOClient.ConnectOpts
    ): void {
        this.sioClient = io(url, options);
        // add listeners
        this.sioClient.removeAllListeners();
        for (const event of Object.values(this.allEvents)) {
            this.sioClient.addEventListener(event.name, event.listener);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/web-socket/web-socket-io-base.ts